/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown>, in_the: NonNullable<unknown> }} Wrapped_Lift_GainInputs */

const en_us2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const pt_br2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const es_419_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const pt_pt2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const fr_fr2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const de_de2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

const it_it2_wrapped_lift_gain = /** @type {(inputs: Wrapped_Lift_GainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} ${i?.in_the}`)
};

/**
* | output |
* | --- |
* | "{deltaText} {in_the}" |
*
* @param {Wrapped_Lift_GainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_lift_gain = /** @type {((inputs: Wrapped_Lift_GainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Lift_GainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_lift_gain(inputs)
	if (locale === "es-419") return es_419_wrapped_lift_gain(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_lift_gain(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_lift_gain(inputs)
	if (locale === "de-DE") return de_de2_wrapped_lift_gain(inputs)
	if (locale === "it-IT") return it_it2_wrapped_lift_gain(inputs)
	return en_us2_wrapped_lift_gain(inputs)
});
export { wrapped_lift_gain as "wrapped.lift_gain" }